import React from 'react';
import { Button } from './ui/button';

// Clean WhatsApp SVG (keeps crisp on all screen sizes)
const WhatsAppIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" className="h-9 w-9">
    <g transform="scale(1.15) translate(-2 -2)"><path d="M16.027 3C9.39 3 4 8.39 4 15.027c0 2.65.86 5.097 2.327 7.097L4.6 28.4l6.42-1.693A12.94 12.94 0 0 0 16.027 27C22.663 27 28 21.61 28 14.973 28 8.337 22.663 3 16.027 3zm0 22.276c-2.15 0-4.173-.63-5.887-1.827l-.42-.28-3.81 1.003 1.017-3.71-.273-.44A10.24 10.24 0 0 1 5.76 15c0-5.67 4.597-10.276 10.267-10.276 5.67 0 10.276 4.606 10.276 10.276 0 5.67-4.606 10.276-10.276 10.276zm5.113-7.67c-.28-.14-1.653-.82-1.91-.913-.256-.094-.443-.14-.63.14-.187.28-.723.913-.89 1.1-.166.187-.33.21-.61.07-.28-.14-1.18-.44-2.243-1.403-.83-.74-1.39-1.653-1.553-1.933-.163-.28-.017-.43.123-.57.13-.13.28-.33.42-.496.14-.163.187-.28.28-.47.093-.187.047-.35-.023-.49-.07-.14-.63-1.52-.863-2.083-.226-.543-.457-.47-.63-.48l-.54-.01c-.187 0-.49.07-.75.35-.26.28-.99.97-.99 2.36 0 1.39 1.01 2.733 1.15 2.92.14.187 1.987 3.027 4.963 4.273.694.3 1.236.48 1.66.617.696.22 1.33.19 1.833.12.56-.083 1.653-.676 1.887-1.33.233-.653.233-1.213.163-1.33-.07-.116-.257-.186-.537-.326z" /></g>
  </svg>
);

export const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const phone = '+919116967045';
    const message = encodeURIComponent('Hello, I would like to inquire about your die casting services.');
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50" aria-hidden={false}>
      {/* subtle pulsing ring */}
      <span
        className="absolute inset-0 rounded-full bg-[#25D366]/30 animate-pulse-slow"
        style={{ width: 56, height: 56, margin: 'auto', transformOrigin: 'center' }}
      />

      <Button
        onClick={handleWhatsAppClick}
        size="icon"
        aria-label="Chat on WhatsApp"
        className="
          relative h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20
          hover:bg-[#1EBE5A] hover:scale-110 active:scale-95 transition-all duration-200
          flex items-center justify-center
        "
      >
        <WhatsAppIcon />
      </Button>
    </div>
  );
};

export default WhatsAppButton;
